'use es6';

export const ALL_EMAILS = ['allEmails'];
export const AVATAR = ['avatar'];
export const CANONICAL_VID = ['canonicalVid'];
export const CONTACT = ['contact'];
export const EMAIL = ['email'];
export const FIRST_NAME = ['firstName'];
export const LAST_NAME = ['lastName'];
export const VID = ['vid'];